<template>
    <div class="jump-cart">
        <van-nav-bar title="积分订单列表" left-arrow fixed class="jump-nav-bar" @click-left="back">
            <!-- <div slot="right" class="jump-nav-bar-rhd">
                <i class="iconfont icon-sousuo"></i><span>管理</span>
            </div> -->
        </van-nav-bar>
        <div class="jump-cart-body">
            <!-- <div class="jump-cart-body-hd"></div> -->
            <!-- <van-tabs v-model="tabActive" @click="getOrderData" style="margin-bottom: 20px;">
                <van-tab title="全部"></van-tab>
                <van-tab title="已付款"></van-tab>
                <van-tab title="已发货"></van-tab>
                <van-tab title="已完成"></van-tab>
            </van-tabs> -->

            <van-row style="margin-bottom: 10px">
                <van-cell-group>
                    <van-field
                            v-model="startTime"
                            label="开始时间"
                            placeholder="请选择开始时间"
                            @focus="showDate"
                            readonly
                    >
                     <!-- <van-button slot="button" size="small" type="primary" @click="startTime=''">清空</van-button> -->
                    </van-field>
                    <van-field
                            v-model="endTime"
                            label="结束时间"
                            placeholder="请选择结束时间"
                            @focus="showDate1"
                            readonly
                    />

                    <van-field
                            v-model="name"
                            label="商品名称"
                            placeholder="请输入商品名称"
                    >
                    </van-field>
                    <van-field style="line-height:40px"
                            v-model="code"
                            label="兑换单号"
                            placeholder="请输入兑换单号"
                    >
                        <van-button slot="button" size="small" type="primary" @click="seach">确定</van-button>
                    </van-field>


                </van-cell-group>
            </van-row>

            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-row class="jump-cart-item" v-for="item in list">
                    <van-row v-if="item.carts.length>0">
                        <van-col span="10" class="jump-cart-item-img">
                            <img :src="item.carts[0].imges"/>
                        </van-col>
                        <van-col span="14" class="jump-cart-item-warp">
                            <p class="item-time">{{item.createtime | formatTime('yyyy-MM-dd')}} <span
                                    class="order-cancel">{{item.igoStatusName}}</span>
                            </p>
                            <p class="text-ellipsis">{{item.carts[0].goodsName}}</p>
                            <p>兑换积分：{{item.igoTotalIntegral}}分</p>
                        </van-col>
                        <van-col span="24" class="jump-cart-item-foot">
                            <van-button size="small" plain class="btn-cancel" @click="shouhuo(item.id)"
                                        v-if="item.igoStatus == 30">
                                确认收货
                            </van-button>
                            <van-button size="small" plain class="btn-cancel" @click="seeOrder(item.id)"
                            >
                                查看详情
                            </van-button>

                        </van-col>
                    </van-row>
                </van-row>
            </van-list>
        </div>
        <BackTop/>
        <!-- 结束时间     :min-date="minDate"-->
        <van-popup v-model="popDateShow1" position="bottom" :overlay="true">
            <van-datetime-picker
                    v-model="currentDate1"
                    type="date"
                    @cancel="popDateShow1 = false"
                    @confirm="onDateConfirm1"
            />
        </van-popup>
<!-- 开始时间 -->
        <van-popup v-model="popDateShow" position="bottom" :overlay="true">
            <van-datetime-picker
                    v-model="currentDate"
                    type="date"
                    @cancel="popDateShow = false"
                    @confirm="onDateConfirm"

            />
        </van-popup>
    </div>
</template>
<script>
    import {
        NavBar,
        Row,
        Col,
        Button,
        tab,
        tabs,
        Tab,
        Tabs,
        List,
        DatetimePicker,
        Cell,
        CellGroup,
        Field,
        Picker,
        Popup
    } from "vant"

    export default {
        name: "userIntegralOrder",
        components: {
            [DatetimePicker.name]: DatetimePicker,
            [Cell.name]: Cell,
            [CellGroup.name]: CellGroup,
            [Field.name]: Field,
            [Picker.name]: Picker,
            [Popup.name]: Popup,
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [Button.name]: Button,
            [Tab.name]: Tab,
            [Tabs.name]: Tabs,
            [List.name]: List
        },
        data() {
            return {
                checkedAll: false,
                tabActive: 0,
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1,
                type: 0,
                popDateShow: false,
                currentDate: new Date(),
                popDateShow1: false,
                currentDate1: new Date(),
                startTime: '',
                endTime: '',
                name: '',
                code: '',
                // minDate:new Date()
            };
        },
        methods: {
            showDate() {
                this.popDateShow = true;
            },
            onDateConfirm(value) {
                const d = new Date(value)
                const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate())
                // const resTime = this.p(d.getHours()) + ':' + this.p(d.getMinutes()) + ':' + this.p(d.getSeconds())
                // this.startTime = resDate + ' ' + resTime;
                this.startTime = resDate;
                // this.minDate=value;
                this.popDateShow = false;
            }, showDate1() {
                this.popDateShow1 = true;
            },
            onDateConfirm1(value) {//结束时间
                const d = new Date(value)
                const resDate = d.getFullYear() + '-' + this.p((d.getMonth() + 1)) + '-' + this.p(d.getDate())
                // const resTime = this.p(d.getHours()) + ':' + this.p(d.getMinutes()) + ':' + this.p(d.getSeconds())
                // this.endTime = resDate + ' ' + resTime;
                this.endTime = resDate;
                this.popDateShow1 = false;
            }, p(s) {
                return s < 10 ? '0' + s : s
            },
            seach() {
                let that = this
                that.list = []
                that.page = 1
                that.$api.post(
                    that.jumuc.integral.orderList,
                    {"currentPage": that.page, "pageSize": 10,"goodsName":that.name,
                    "beginTime":that.startTime,"endTime":that.endTime,"orderId":that.code},
                    successRes => {
                        let orderlist = successRes.data.list
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                         that.page = successRes.data.pageNum + 1
                         that.total = successRes.data.total
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (this.list.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )
            },
            onLoad() {
                let that = this
                let json = {"currentPage": that.page}
                if (that.type != 1) {
                    json = {"currentPage": that.page}
                }
                // 异步更新数据
                that.$api.post(
                    that.jumuc.integral.orderList,
                    json,
                    successRes => {
                        let orderlist = successRes.data.list
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        that.page = successRes.data.pageNum + 1
                        that.total = successRes.data.total
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (this.list.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )

            },
            getOrderData(index, title) {
                let that = this
                that.list = []
                let json = {"currentPage": that.page}
                if (index != 0) {
                    if (index == 6) {
                        index = 0
                    }
                    that.page = 1
                    that.type = index * 10
                    json = {"currentPage": that.page}
                } else {
                    that.type = 1
                }
                that.$api.post(
                    that.jumuc.integral.orderList,
                    json,
                    successRes => {
                        that.list = successRes.data.list
                        that.page = successRes.data.pageNum + 1
                        that.total = successRes.data.total
                    }
                )
            }, back() {
                //history.back()
                this.$router.push({
                    path: '/usercent'
                })
            },
            seeOrder(orderId) {
                this.$router.push({
                    path: '/user/integral/order/detail',
                    query: {
                        id: orderId
                    }
                })
            }, shouhuo(orderId) {
                let that = this
                that.$router.push({
                    path: '/user/integral/order/receive',
                    query: {
                        id: orderId
                    }
                })
            }
        },
        mounted: function () {
            let that = this
            that.type = that.$route.query.type
            that.tabActive = that.type / 10
            that.tabActive = that.tabActive == 0 ? 6 : that.tabActive
        }, filters: {
            formatTime: function (date, fmt) {
                var date = new Date(date.replace(/-/g, "/"));
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
                }
                var o = {
                    'M+': date.getMonth() + 1,
                    'd+': date.getDate(),
                    'h+': date.getHours(),
                    'm+': date.getMinutes(),
                    's+': date.getSeconds()
                };
                for (var k in o) {
                    if (new RegExp('(' + k + ')').test(fmt)) {
                        var str = o[k] + '';
                        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : ('00' + str).substr(str.length));
                    }
                }
                return fmt;
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    button {
        margin: 5px;
    }

    .jump-cart {

        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 90%;
                }
            }

            h4 {
                font-size: 16px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 16px;
                &.item-time {
                    font-size: 16px;
                    span {
                        float: right;
                        color: @bule-thame;
                    }
                    span.order-cancel {
                        color: green;
                    }
                }
                &.item-price {
                    font-size: 16px;
                    text-align: right;
                }
            }
            &-foot {
                padding: 10px 0;
                text-align: right;
                button {
                    margin-left: 10px;
                    padding: 0 10px;
                    border-radius: 10px;
                    color: #999;
                    border-color: #999;
                }
                button.btn-cancel {
                    color: @bule-thame;
                    border-color: @bule-thame;
                }
            }
        }

    }
</style>

